import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';

import { CopyIcon } from '@primer/octicons-react';
import { StyledOcticon } from '@primer/react';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import { FONT_SIZES } from '../../../constants/font.constants';

import Label from '../Labels/Label';
import { useToastContext } from '../Toast/ToastContext';

type ClipboardLabelProps = {
  className?: string | undefined,
  labelValue: string,
  displayLabel: string,
  onCopyResult?: (val: string, copied: boolean) => void | undefined,
  iconSize?: number
  labelSize?: string,
  LabelComponent?: any,
  showClipboardIconOnHover?: boolean,
}

export const ClipboardLabel = ({
  className, 
  labelValue,
  displayLabel,
  onCopyResult,
  iconSize = 24,
  labelSize = FONT_SIZES.SM,
  LabelComponent = Label,
  showClipboardIconOnHover = false,
}: ClipboardLabelProps) => {
  const [showClipboard, setShowClipboard] = useState(false);
  const { showToast } = useToastContext();

  const onCopy = useCallback((text, copied) => {
    // @ts-ignore
    showToast(copied ? 'Copied to Clipboard!' : 'Could not copy to clipboard');
    if (isFunction(onCopyResult)) {
      onCopyResult(text, copied);
    }
  }, [onCopyResult, showToast])

  const onMouseEvents = showClipboardIconOnHover ? {
    onMouseLeave: () => setShowClipboard(false),
    onMouseEnter: () => setShowClipboard(true),
  } : {}
  
  return (
    <CopyToClipboard
      text={labelValue}
      onCopy={onCopy}
    >
      <button
        type="button"
        onClick={e => e.stopPropagation()}
        className={classNames('flex flex-row items-center justify-center', className)}
        {...onMouseEvents}
      >
        <LabelComponent
          title={labelValue}
          size={labelSize}
        >
          { displayLabel }
        </LabelComponent>
        {
          showClipboard && (
            <StyledOcticon
              className="ml-1"
              icon={CopyIcon}
              size={iconSize}
            />
          )
        }
      </button>
    </CopyToClipboard>
  );
}

export default ClipboardLabel;
